import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { TrackEventContext } from 'common/containers/EventContainer';
import LandingSalesDocumentationHelmet from 'common/helmets/LandingSalesDocumentationHelmet';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';
import Link from 'common/Link';
import withContexts from 'common/util/withContexts';
import LandingCTAButtons from 'common/www/LandingCTAButtons';
import LandingFeaturesCTA from 'common/www/LandingFeaturesCTA';
import Point2 from 'img/landing/changelog-1.webp';
import Point1 from 'img/landing/internal-feedback-1.webp';
import Hero from 'img/landing/sales-hero.webp';

import 'css/components/www/_LandingSolutionsPage.scss';

class LandingSalesDocumentation extends Component {
  static propTypes = {
    trackEvent: PropTypes.func,
  };

  componentDidMount() {
    const { trackEvent } = this.props;
    trackEvent('Viewed Sales Documentation Landing Page');
  }

  render() {
    return (
      <div className="landingSalesDocumentation landingSolutionsPage">
        <LandingSalesDocumentationHelmet />
        <div className="fullWidthContainer">
          <div className="header">
            <div className="left">
              <div className="text">
                <h1>Sales and product should empower each&nbsp;other</h1>
                <p className="subheading">
                  A dedicated feedback management tool can help with sales documentation. This helps
                  product teams prioritize high-impact&nbsp;features.
                </p>
                <LandingCTAButtons renderDemoButton />
              </div>
            </div>
            <LazyLoadedImage loading="eager" src={Hero} className="noHide" alt="Sales graphic" />
          </div>
        </div>
        <div className="mainContentContainer">
          <h2>Canny enables sales to stay in touch with&nbsp;product</h2>
          <div className="point">
            <LazyLoadedImage
              loading="eager"
              src={Point1}
              alt="Sales teams can keep track of what customers want"
            />
            <div className="text">
              <h2 className="title">Keep track of what your accounts&nbsp;want</h2>
              <p>
                Personalization is important in sales. Having proper sales documentation about what
                your prospect has asked for helps build a more personal&nbsp;relationship.
              </p>
              <ul>
                <li>Pull up your accounts to see everything they've voted&nbsp;on</li>
                <li>
                  Include helpful insights from your accounts about their use case for the
                  product&nbsp;team
                </li>
                <li>
                  Help the product team prioritize by showing them which customers are
                  requesting&nbsp;features
                </li>
              </ul>
            </div>
          </div>
          <div className="point">
            <LazyLoadedImage
              src={Point2}
              alt="Understand what product is working on to close deals"
            />
            <div className="text">
              <h2 className="title">Stay in touch with product&nbsp;updates</h2>
              <p>
                It’s easy for new features to go unnoticed. This is a missed opportunity
                for&nbsp;sales.
              </p>
              <ul>
                <li>
                  Use the company <Link to="/features/product-changelog">changelog</Link> to see
                  what's new in your product and entice&nbsp;prospects
                </li>
                <li>Check the roadmap to see if customer asks are on the&nbsp;way</li>
                <li>Stop chasing product managers to get updates on specific&nbsp;features</li>
              </ul>
            </div>
          </div>
          <LandingFeaturesCTA />
          <LandingFooterCTA style="solid" expanded={true} />
        </div>
      </div>
    );
  }
}

export default withContexts({ trackEvent: TrackEventContext })(LandingSalesDocumentation);
